import { navItems } from '@/utils/enums/navItems';

export const publicRoutes = [
  'login',
  'loginIndex',
  'recover',
  'reset',
  'onboard',
];

export const whiteListedRoutes = [
  'permissionDenied',
  'generatedV2',
  'configuredV2',
  'login',
  'loginIndex',
  'recover',
  'reset',
  'onboard',
  'loadingPage',
];

export const whiteListedCapabilities = ['alertsV2'];

export const APM_RESOURCE_GROUP = 'A';
export const BROWSER_RESOURCE_GROUP = 'B';
export const HOME_RESOURCE_GROUP = 'HOME';
export const DATABASE_RESOURCE_GROUP = 'D';
export const VM_RESOURCE_GROUP = 'V';
export const MOBILE_RESOURCE_GROUP = 'M';
export const K8S_RESOURCE_GROUP = 'K';
export const CLOUD_RESOURCE_GROUP = 'C';
export const LOG_RESOURCE_GROUP = 'L';
export const ANALYTICS_RESOURCE_GROUP = 'ANL';
export const DE_RESOURCE_GROUP = 'DEX';
export const MQ_RESOURCE_GROUP = 'Q';
export const BILLING_RESOURCE_GROUP = 'USAGE';
export const CONFIG_RESOURCE_GROUP = 'CONFIG';
export const NOTIFICATION_RESOURCE_GROUP = 'NOTIFICATION';
export const SYNTHETIC_RESOURCE_GROUP = 'S';
export const INTEGRATIONS_RESOURCE_GROUP = 'INTEGRATION';

export const resouceGroupRouteMap = {
  [navItems.APM]: APM_RESOURCE_GROUP,
  [navItems.BROWSER]: BROWSER_RESOURCE_GROUP,
  [navItems.HOME]: HOME_RESOURCE_GROUP,
  [navItems.NOTIFICATION]: NOTIFICATION_RESOURCE_GROUP,
  [navItems.SM]: SYNTHETIC_RESOURCE_GROUP,
  [navItems.DATABASE]: DATABASE_RESOURCE_GROUP,
  [navItems.MQ]: MQ_RESOURCE_GROUP,
  [navItems.VM]: VM_RESOURCE_GROUP,
  [navItems.MOBILE]: MOBILE_RESOURCE_GROUP,
  [navItems.K8M]: K8S_RESOURCE_GROUP,
  [navItems.INTEGRATIONS]: INTEGRATIONS_RESOURCE_GROUP,
  [navItems.CLOUD]: CLOUD_RESOURCE_GROUP,
  subscriptionId: CLOUD_RESOURCE_GROUP,
  databaseId: CLOUD_RESOURCE_GROUP,
  individualGraph: CLOUD_RESOURCE_GROUP,
  [navItems.LOG]: LOG_RESOURCE_GROUP,
  [navItems.ANALYTICS]: ANALYTICS_RESOURCE_GROUP,
  [navItems.DE]: DE_RESOURCE_GROUP,
  [navItems.BILLING]: BILLING_RESOURCE_GROUP,
  [navItems.SETTINGS]: CONFIG_RESOURCE_GROUP,
};

export const capabilityResourceGroupMap = {
  [APM_RESOURCE_GROUP]: APM_RESOURCE_GROUP,
  [BROWSER_RESOURCE_GROUP]: BROWSER_RESOURCE_GROUP,
  [HOME_RESOURCE_GROUP]: HOME_RESOURCE_GROUP,
  [NOTIFICATION_RESOURCE_GROUP]: NOTIFICATION_RESOURCE_GROUP,
  [SYNTHETIC_RESOURCE_GROUP]: SYNTHETIC_RESOURCE_GROUP,
  [DATABASE_RESOURCE_GROUP]: DATABASE_RESOURCE_GROUP,
  [VM_RESOURCE_GROUP]: VM_RESOURCE_GROUP,
  [MOBILE_RESOURCE_GROUP]: MOBILE_RESOURCE_GROUP,
  [K8S_RESOURCE_GROUP]: K8S_RESOURCE_GROUP,
  [INTEGRATIONS_RESOURCE_GROUP]: INTEGRATIONS_RESOURCE_GROUP,
  [CLOUD_RESOURCE_GROUP]: CLOUD_RESOURCE_GROUP,
  [LOG_RESOURCE_GROUP]: LOG_RESOURCE_GROUP,
  [ANALYTICS_RESOURCE_GROUP]: ANALYTICS_RESOURCE_GROUP,
  [DE_RESOURCE_GROUP]: DE_RESOURCE_GROUP,
  [BILLING_RESOURCE_GROUP]: BILLING_RESOURCE_GROUP,
  [CONFIG_RESOURCE_GROUP]: CONFIG_RESOURCE_GROUP,
  [MQ_RESOURCE_GROUP]: MQ_RESOURCE_GROUP,
};

export const resourceGroupRouteList = [
  //order needs to be maintained in sync with TheSideNavBar getNavItems
  {
    name: 'home',
    resourceGroup: HOME_RESOURCE_GROUP,
  },
  {
    name: 'notification',
    resourceGroup: NOTIFICATION_RESOURCE_GROUP,
  },
  {
    name: 'apm',
    resourceGroup: APM_RESOURCE_GROUP,
  },
  {
    name: 'browser',
    resourceGroup: BROWSER_RESOURCE_GROUP,
  },
  {
    name: 'sm',
    resourceGroup: SYNTHETIC_RESOURCE_GROUP,
  },
  {
    name: 'database',
    resourceGroup: DATABASE_RESOURCE_GROUP,
  },
  {
    name: 'mq',
    resourceGroup: MQ_RESOURCE_GROUP,
  },
  {
    name: 'vm',
    resourceGroup: VM_RESOURCE_GROUP,
  },
  {
    name: 'mobile',
    resourceGroup: MOBILE_RESOURCE_GROUP,
  },
  {
    name: 'k8m',
    resourceGroup: K8S_RESOURCE_GROUP,
  },
  {
    name: 'integrations',
    resourceGroup: INTEGRATIONS_RESOURCE_GROUP,
  },
  {
    name: 'cloud',
    resourceGroup: CLOUD_RESOURCE_GROUP,
  },
  {
    name: 'log',
    resourceGroup: LOG_RESOURCE_GROUP,
  },
  {
    name: 'analytics',
    resourceGroup: ANALYTICS_RESOURCE_GROUP,
  },
  {
    name: 'digitalExperience',
    resourceGroup: DE_RESOURCE_GROUP,
  },
  {
    name: 'usages',
    resourceGroup: BILLING_RESOURCE_GROUP,
  },
  {
    name: 'settings',
    resourceGroup: CONFIG_RESOURCE_GROUP,
  },
];

export const permissionTypes = Object.freeze({
  READ: 'READ',
  WRITE: 'WRITE',
  ALERT_READ: 'ALERT_READ',
  ALERT_WRITE: 'ALERT_WRITE',
});
